const firebaseConfig = {
  apiKey: "AIzaSyAiiKIXlf3W8SIqUpG-tBLFdbRqJ-92pQs",
  authDomain: "volunteer-network-c9518.firebaseapp.com",
  databaseURL: "https://volunteer-network-c9518.firebaseio.com",
  projectId: "volunteer-network-c9518",
  storageBucket: "volunteer-network-c9518.appspot.com",
  messagingSenderId: "912086287975",
  appId: "1:912086287975:web:daaf2e2faefe6314b7f6c2",
};

export default firebaseConfig;
